import createCachedSelector from "re-reselect";
import * as actions from "./actionCreators";

const ids = (filters, page, pageSize, state) => {
  const key = actions.loadFacilitiesKey(filters, pageSize);
  const facilities = state.facilities.list[key];
  if (!facilities) {
    return [];
  }

  const result = facilities[page] ? facilities[page].ids : [];
  return result ? result : [];
};

const facilities = (filters, page, pageSize, state) =>
  state.facilities.entities.facilities ? state.facilities.entities.facilities : [];

export const getFacilitiesCached = createCachedSelector(ids, facilities, (ids, facilities) =>
  ids.map(id => facilities[id])
)(
  // eslint-disable-next-line no-unused-vars
  (filters, page, pageSize, state) => actions.loadFacilitiesKey(filters, pageSize)
);

export const getFacilities = (filters, page, pageSize, state) => {
  const key = actions.loadFacilitiesKey(filters, pageSize);
  const facilities = state.facilities.list[key];

  const loading = facilities && facilities[page] ? facilities[page].loading : false;
  const totalCount = facilities && facilities.totalCount ? facilities.totalCount : 0;
  const content = getFacilitiesCached(filters, page, pageSize, state);

  return { loading, content, totalCount };
};
